export default __webpack_public_path__ + "static/media/icon_login_social_kakao.9d8289ef.svg";